/**
 * Product Card Title Ellipsis
 * Detecta cuando el título de un producto va a hacer un salto de línea
 * y aplica ellipsis (...) en su lugar
 * 
 * Excluye:
 * - Carruseles "Destacados" (featured-collection, section-featured-collection)
 * - Carruseles "Guia de regalos" (se buscará por clase o sección específica)
 * - Carrusel del carrito (LOP-cart-drawer--recommended-products)
 */

(function() {
  'use strict';

  /**
   * Verifica si un elemento está dentro de una sección excluida
   */
  function isExcluded(element) {
    // Excluir carrusel del carrito
    if (element.closest('.LOP-cart-drawer--recommended-products')) {
      return true;
    }

    // Excluir secciones "Destacados" (featured-collection)
    if (element.closest('.featured-collection') || 
        element.closest('.section-featured-collection')) {
      return true;
    }

    // Excluir "Guia de regalos" - buscar por texto del heading o clase específica
    // Si hay una sección específica con este nombre, se puede identificar aquí
    const parentSection = element.closest('section');
    if (parentSection) {
      const heading = parentSection.querySelector('h2, h3, .section-header h2, .section-header h3');
      if (heading) {
        const headingText = heading.textContent.toLowerCase().trim();
        if (headingText.includes('guia de regalos') || 
            headingText.includes('guía de regalos')) {
          return true;
        }
      }
    }

    return false;
  }

  /**
   * Aplica ellipsis a un título si se desborda
   */
  function applyEllipsis(titleElement) {
    // Si ya tiene ellipsis aplicado, remover para recalcular
    const wasApplied = titleElement.classList.contains('lop-title-ellipsis-applied');
    if (wasApplied) {
      titleElement.classList.remove('lop-title-ellipsis-applied');
      titleElement.style.overflow = '';
      titleElement.style.textOverflow = '';
      titleElement.style.whiteSpace = '';
    }

    // Guardar estilos originales
    const computedStyle = window.getComputedStyle(titleElement);
    const originalOverflow = titleElement.style.overflow || computedStyle.overflow;
    const originalTextOverflow = titleElement.style.textOverflow || computedStyle.textOverflow;
    const originalWhiteSpace = titleElement.style.whiteSpace || computedStyle.whiteSpace;

    // Resetear temporalmente para medir correctamente
    titleElement.style.overflow = 'visible';
    titleElement.style.textOverflow = '';
    titleElement.style.whiteSpace = 'normal';

    // Obtener dimensiones del elemento
    const scrollHeight = titleElement.scrollHeight;
    const clientHeight = titleElement.clientHeight || titleElement.offsetHeight;
    
    // Calcular altura de una línea
    const fontSize = parseFloat(computedStyle.fontSize);
    const lineHeight = computedStyle.lineHeight;
    let singleLineHeight;
    
    if (lineHeight === 'normal') {
      singleLineHeight = fontSize * 1.2; // Valor por defecto típico
    } else if (lineHeight.includes('px')) {
      singleLineHeight = parseFloat(lineHeight);
    } else if (lineHeight.includes('%') || lineHeight.includes('em')) {
      singleLineHeight = fontSize * parseFloat(lineHeight);
    } else {
      singleLineHeight = fontSize * parseFloat(lineHeight);
    }
    
    // Si la altura del contenido es mayor que una línea (con un pequeño margen de tolerancia)
    // Aplicar ellipsis para mantener una sola línea
    if (scrollHeight > singleLineHeight + 1) {
      titleElement.style.overflow = 'hidden';
      titleElement.style.textOverflow = 'ellipsis';
      titleElement.style.whiteSpace = 'nowrap';
      titleElement.classList.add('lop-title-ellipsis-applied');
    } else {
      // Restaurar estilos originales si no necesita ellipsis
      titleElement.style.overflow = originalOverflow === 'visible' ? '' : originalOverflow;
      titleElement.style.textOverflow = originalTextOverflow === 'clip' ? '' : originalTextOverflow;
      titleElement.style.whiteSpace = originalWhiteSpace === 'normal' ? '' : originalWhiteSpace;
    }
  }

  /**
   * Procesa todos los títulos de productos
   */
  function processTitles() {
    const titles = document.querySelectorAll('.product-card-title');
    
    titles.forEach(title => {
      // Excluir títulos en secciones excluidas
      if (isExcluded(title)) {
        return;
      }

      // Aplicar ellipsis si es necesario
      applyEllipsis(title);
    });
  }

  /**
   * Inicialización
   */
  function init() {
    // Procesar títulos al cargar
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', processTitles);
    } else {
      processTitles();
    }

    // Procesar títulos después de cambios dinámicos en el DOM
    // Usar MutationObserver para detectar cuando se agregan nuevos productos
    const observer = new MutationObserver(function(mutations) {
      let shouldProcess = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Si se agregó un product-card o un título, procesar
              if (node.classList && (
                node.classList.contains('product-card') ||
                node.querySelector('.product-card-title')
              )) {
                shouldProcess = true;
              }
            }
          });
        }
      });

      if (shouldProcess) {
        // Usar setTimeout para agrupar múltiples cambios
        setTimeout(processTitles, 100);
      }
    });

    // Observar cambios en el body
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // También procesar cuando se redimensiona la ventana
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        // Remover ellipsis aplicados para recalcular
        document.querySelectorAll('.lop-title-ellipsis-applied').forEach(function(title) {
          title.classList.remove('lop-title-ellipsis-applied');
          title.style.overflow = '';
          title.style.textOverflow = '';
          title.style.whiteSpace = '';
        });
        processTitles();
      }, 250);
    });
  }

  // Iniciar
  init();
})();

